module.exports = __webpack_public_path__ + "img/Group_42443@2x.1720c15e.png";